var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5762 7.82898C10.5762 13.0736 8.59075 16 5.15445 16C2.09996 16 0.0381811 13.1876 0 8.05701C0 2.85036 2.25268 0 5.42172 0C8.70529 0 10.5762 2.92637 10.5762 7.82898ZM2.13814 8.05701C2.13814 12.0855 3.39812 14.3658 5.30717 14.3658C7.44531 14.3658 8.4762 11.8575 8.4762 7.90499C8.4762 4.06651 7.52168 1.5962 5.30717 1.5962C3.47448 1.6342 2.13814 3.87648 2.13814 8.05701Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0);
export default __webpack_public_path__ + "static/media/0.4c19be0238a2ed588b46c542a5699f45.svg";
export { ForwardRef as ReactComponent };